$(function(){
  setupTagIt();
});

function actualizeTagItInputValue(e,ui){
  $($(e.target).data('target')).val($(e.target).tagit('assignedTags').join());
}

function setupTagIt(){
  if (typeof $('.tagit-input').tagit === 'function'){
    $('.tagit-input').each(function(index){
      var ul = $('<ul class="tag-it"></ul>');
      ul.insertBefore($(this));
      ul.data('target', '#tagit-input-' + index);
      if(typeof $(this).data('placeholder') !== 'undefined'){
        ul.data('placeholder', $(this).data('placeholder'));
      }
      else{
        ul.data('placeholder', localizedTexts.dev.emailsSeparator)
      }
      $(this).attr('id', 'tagit-input-' + index).css({display: 'none'});
    });

    $('.tag-it').each(function(){
      var placeholder = $(this).data('placeholder') || localizedTexts.dev.emails;
      var that = this;
      $(that).tagit({
        placeholderText: placeholder,
        afterTagAdded: actualizeTagItInputValue,
        afterTagRemoved: actualizeTagItInputValue,
        beforeTagAdded: function(event, obj) {
          var splitted = obj.tagLabel.split(/[\s,]+/);
          
          if (splitted.length > 1) {
            for (var i=0; i<splitted.length; ++i) {
              $(that).tagit("createTag", splitted[i]);
            }
            return false;
          }
        }
      });

      $(this).find('input').focusin(function(){
        $(this).closest('.tag-it').addClass('focused');
      }).focusout(function(){
        $(this).closest('.tag-it').removeClass('focused');
      });
    });
  }
}
